import { render, staticRenderFns } from "./RefectoryRecord.vue?vue&type=template&id=8273d39a&scoped=true"
import script from "./RefectoryRecord.vue?vue&type=script&lang=js"
export * from "./RefectoryRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8273d39a",
  null
  
)

export default component.exports